import Accordion from './accordion'
/**
 * scrollToHash
 * @description Scroll the #main area after each smoothState reload.
 * If a hash id is present, scroll to the location of that element,
 * taking into account the height of the navbar.
 */

/**
 * scrollWindow
 * @description scroll viewport to a certain vertical offset, minus the height of the quire navbar
 * TODO add animation duration and style of easing function previously provided by jQuery `.animate()`
 */
function scrollWindow(verticalOffset, animationDuration = null, animationStyle = null) {
  const navBar = document.querySelector('.quire-navbar')
  const extraSpace = 7
  const scrollDistance = navBar
    ? verticalOffset - navBar.clientHeight - extraSpace
    : verticalOffset - extraSpace
  // redundancy here to ensure all possible document properties with `scrollTop` are being set for cross-browser compatibility
  const documentProperties = [
    document.documentElement,
    document.body.parentNode,
    document.body
  ]
  documentProperties.forEach((element) => {
    element.scrollTop = scrollDistance
  })
}

export default (hash) => {
  if (!hash) return

  // prefix all ':' and '.' in hash with '\\' to make them query-selectable
  hash = hash.replace(':', '\\:')
  hash = hash.replace('.', '\\.')

  // Figure out element to scroll to, returning if none
  const target = document.querySelector(hash)

  if (!target) return

  // If the target sets URL params assign them
  if (Accordion.partOfAccordion(target)) {
    const accordion = new Accordion(target.closest(`.${Accordion.className}`))

    accordion.setStateFromUrl()
  }

  const verticalOffset = target.getBoundingClientRect().top + window.scrollY;
  scrollWindow(verticalOffset)
  // Restore focus to hash-scrolled element
  setTimeout(() => target.focus())

  // For non-slide targets, scroll the window and move on
  if (target.className === 'exhibition-section--slide') {
    // Calculate the offset for the slide movement keyframes
    const slideMoving = [
      { transform: `translateY(-${target.getBoundingClientRect().top}px)` },
      { transform: "translateY(0px)" }
    ];

    const slideTiming = {
      duration: 2000,
      iterations: 1,
    };

    target.animate(slideMoving, slideTiming)
  }
}
